import { prop } from '@gov-nx/core/types/helpers.types';
import { usePersistedStore } from '../constants';

type FormStore = {
	[name: string]: object | null;
	update: (name: string, value: object) => void;
	reset: (name: string) => void;
};

const initialState = {};

const useStore = <T>(selector: (state: FormStore) => T) =>
	usePersistedStore(
		(set) => ({
			...initialState,
			update: (name, value) => set({ [name]: value }),
			reset: (name) => set({ [name]: null }),
		}),
		'forms',
		selector
	);

export const useFormStore = <T extends keyof FormStore>(
	property: T
): FormStore[T] => useStore(prop(property));
